/* eslint-disable no-undef, no-console */
/**
 * DebugHelper object.
 */
DebugHelper = typeof DebugHelper !== 'undefined' ? DebugHelper : {};
DebugHelper.enableDebug = false;
DebugHelper.initialized = false;
DebugHelper.prefix = 'Markem-Imaje Debug -';

/**
 * DebugHelper library.
 */
(function () {
  'use strict';

  /**
   * @returns {undefined}
   */
  DebugHelper.error = function () {
    if (!DebugHelper.enableDebug) {
      return;
    }
    let sliced = Array.prototype.slice.call(arguments);
    sliced.unshift(DebugHelper.prefix);
    // eslint-disable-next-line no-console
    console.debugHelperError.apply(console, sliced);
  };

  /**
   * @returns {undefined}
   */
  DebugHelper.warn = function () {
    if (!DebugHelper.enableDebug) {
      return;
    }
    let sliced = Array.prototype.slice.call(arguments);
    sliced.unshift(DebugHelper.prefix);
    // eslint-disable-next-line no-console
    console.debugHelperWarn.apply(console, sliced);
  };

  /**
   * @returns {undefined}
   */
  DebugHelper.log = function () {
    if (!DebugHelper.enableDebug) {
      return;
    }
    let sliced = Array.prototype.slice.call(arguments);
    sliced.unshift(DebugHelper.prefix);
    // eslint-disable-next-line no-console
    console.debugHelperLog.apply(console, sliced);
  };

  /**
   * @returns {undefined}
   */
  DebugHelper.debug = function () {
    if (!DebugHelper.enableDebug) {
      return;
    }
    let sliced = Array.prototype.slice.call(arguments);
    sliced.unshift(DebugHelper.prefix);
    // eslint-disable-next-line no-console
    console.debugHelperDebug.apply(console, sliced);
  };

  /**
   * Main initialization method
   * @returns {undefined}
   */
  DebugHelper.init = function () {
    if (this.initialized) {
      return;
    }

    // To interface with project logic.
    this.enableDebug = true;

    console.debugHelperError = console.error;
    console.debugHelperWarn = console.warn;
    console.debugHelperLog = console.log;
    console.debugHelperDebug = console.debug;

    console.error = function () {
      DebugHelper.error.apply(console, Array.prototype.slice.call(arguments));
    };
    console.warn = function () {
      DebugHelper.warn.apply(console, Array.prototype.slice.call(arguments));
    };
    console.log = function () {
      DebugHelper.log.apply(console, Array.prototype.slice.call(arguments));
    };
    console.debug = function () {
      DebugHelper.debug.apply(console, Array.prototype.slice.call(arguments));
    };

    this.initialized = true;
  };

})();

// Init for all pages
DebugHelper.init();
